import { Flex } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

import { PRESETS } from './ImageCard.presets';

export const GlobalStyle = createGlobalStyle`
  & .ant-image-mask {
    background: transparent !important;
  };
`;

export const StyledImageCard = styled.div<{ height: number }>`
  ${({ theme, height }) =>
    `
      & .ant-skeleton, .ant-skeleton-image {
        width: ${utils.rem(PRESETS.card.width)} !important;
        height: ${utils.rem(height)} !important;
        border-radius: ${utils.rem(theme.Spacing.Size.Small)} !important;
      };
      & img {
        border-radius: ${utils.rem(theme.Spacing.Size.Small)};
      };
  `}
`;

export const StyledImageCardHover = styled(Flex)`
  ${({ theme }) => `
    padding: ${utils.rem(theme.Spacing.Size.XSmall)};
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    flex: 1 0 0;
    align-self: stretch;
    background: ${theme.Color.Overlay.Default};
    border-radius: ${utils.rem(theme.Spacing.Size.Small)};
    &:hover span,
    &:focus span,
    &:active span {
      display: inline-block;
    }
`}
`;

export const StyledImageCardHoverHeader = styled(Flex)`
  ${({ theme }) => `
    justify-content: flex-end;
    align-items: flex-start;
    align-self: stretch;
    gap: ${utils.rem(theme.Spacing.Size.XXSmall)};
`}
`;

export const StyledImageCardHoverFooter = styled(Flex)`
  justify-content: flex-end;
  align-items: flex-end;
  align-self: stretch;
`;
